export const SIGNUP_TYPE_PORTABILITY = 'portability'
export const SIGNUP_TYPE_NEWLINE = 'new number'
export const SIGNUP_TYPE_NEW = 'new'
